<template>
    <DCard
        padding
    >
        <CompensationRateForm
            :errors="errors"
            :partner-compensation-rate="partnerCompensationRate"
            @form-submitted="updateCompensationRate"
        />
    </DCard>
</template>

<script>
import CompensationRateForm from '~@/Components/Tools/Partners/CompensationRates/Form'

export default {
    name: 'CompensationRateEdit',
    components: {
        CompensationRateForm
    },
    props: {
        errors: {
            type: Object,
            default: () => { return {} }
        },
        partnerCompensationRate: {
            type: Object,
            default: () => { return {} }
        }
    },
    methods: {
        updateCompensationRate (form) {
            form.put(this.$route('tools.partners.partner-compensation-rates.update', {
                partner_compensation_rate: this.partnerCompensationRate.id
            }))
        }
    }
}
</script>

<style scoped>

</style>
